import Model from './model';

export default class EducationEntry extends Model {
  static NAME = 'education_entry';
  static COLLECTION_NAME = "education_entries";
  static URL = '/api/v2/education_entries';
}